import useGetDevices from '@hooks/api/queries/devices/useGetDevices';
import { useCallback, useMemo } from 'react';

export const useDeviceNameFormatter = () => {
  const { data: devices = [] } = useGetDevices();

  const deviceIdToNameMap = useMemo(
    () => new Map(devices.map((device) => [device.deviceId, device.name])),
    [devices],
  );

  const engineeringIdToNameMap = useMemo(
    () => new Map(devices.map((device) => [device.engineeringId, device.name])),
    [devices],
  );

  return useCallback(
    (deviceId: string): string => {
      return (
        deviceIdToNameMap.get(deviceId) ||
        engineeringIdToNameMap.get(deviceId) ||
        deviceId
      );
    },
    [deviceIdToNameMap, engineeringIdToNameMap],
  );
};
